import useAxios from '../../utils/useAxios'
import { createAsyncThunk } from '@reduxjs/toolkit'
import { rejectWithApiError } from '../../utils/reduxErrors'

export const getDealers = createAsyncThunk('dealers/get', async (...args) => {
  try {
    const axios = useAxios()
    const { data } = await axios.get('/api/dealers/')
    return data
  } catch (error) {
    const { rejectWithValue } = args[1]
    return rejectWithApiError(rejectWithValue, error)
  }
})

export const saveDealer = createAsyncThunk('dealer/save', async (t, { rejectWithValue }) => {
  try {
    const axios = useAxios()
    const { data } = await axios.put(`/api/dealers/${t.id}/`, t)
    return data
  } catch (error) {
    return rejectWithApiError(rejectWithValue, error)
  }
})

export const createDealer = createAsyncThunk('dealer/create', async (t, { rejectWithValue }) => {
  try {
    const axios = useAxios()
    const { data } = await axios.post('/api/dealers/', t)
    return data
  } catch (error) {
    return rejectWithApiError(rejectWithValue, error)
  }
})

export const deleteDealer = createAsyncThunk('dealer/delete', async (t, { rejectWithValue }) => {
  try {
    const axios = useAxios()
    const { data } = await axios.delete(`/api/dealers/${t.id}/`)
    return data
  } catch (error) {
    return rejectWithApiError(rejectWithValue, error)
  }
})
